module.exports = __webpack_public_path__ + "img/score_bg.1c49a43.png";